import React, { Component } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { Button, Col, Row } from 'reactstrap';
import { connect } from 'react-redux';

import _ from 'lodash';
import { API, BASE_URL, SEARCH_DELAY_MS } from 'CONST';
import { CREATE_LINE, GET_MOVIMIENTOS_LIST } from 'redux-store/constants/action-types';
import { cleanData, getData, postData } from 'redux-store/actions/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';

import { headerOperation, cellNumOperation, cellOperation, headerDoubleRowOperation } from 'helpers/tables';
import { get } from 'helpers/requests';
import PageContainer from 'components/PageContainer';
import CreateClientLine from 'components/CreateClientLine';
import BaseTable from './UI/BaseTable';
import Icon from './UI/Icon';
import isUserHasProfile from '../helpers/profileValidator';
import {
  GARANTIA_WRITE,
} from '../helpers/profilePermission';
import RowCardsGroup from './RowCardsGroup';
import DownloadBtn from './shared/DownloadBtn';



const moment = require('moment');

const columns = [
  {
    Header: () => headerOperation('Rut'),
    id: 'rut',
    accessor: i => {
      const color = i.balance.bloqueada ? 'red' : 'inherit';
      return (
        <div style={{ color }}>
          {i.organizacion.rut}
        </div>
      );
    },
    sortable: false,
    minWidth: 70,
  },
  {
    Header: () => headerOperation('Nombre'),
    id: 'nombre',
    accessor: i => cellOperation(i.organizacion.nombre, 'left'),
    sortable: false,
    minWidth: 150,
  },
  {
    Header: () => headerOperation('Exposición máxima (UF)'),
    id: 'exposicion_maxima',
    accessor: i => cellNumOperation(i.balance.exposicion_maxima),
    sortable: false,
    filterable: false,
    minWidth: 100,
  },
  {
    Header: () => headerOperation('Línea Total (UF)'),
    id: 'linea_total',
    accessor: i => cellNumOperation(i.balance.linea_total),
    sortable: false,
    filterable: false,
    minWidth: 100,
  },
  {
    Header: () => headerOperation('Línea General (UF)'),
    id: 'linea_general',
    accessor: i => cellNumOperation(i.balance.linea),
    sortable: false,
    filterable: false,
    minWidth: 100,
  },
  {
    Header: () => headerDoubleRowOperation('Línea Venta en', 'Verde (UF)'),
    id: 'linea_proyectos',
    accessor: i => (
      i.organizacion.roles.includes('afianzadoventaenverde')
        ? cellNumOperation(i.balance.linea_proyectos)
        : cellOperation('-', 'right')
    ),
    sortable: false,
    filterable: false,
    minWidth: 100,
  },
  {
    Header: () => headerOperation('Cúmulo Total (UF)'),
    id: 'cumulo_total',
    accessor: i => cellNumOperation(i.balance.cumulo_total),
    sortable: false,
    filterable: false,
    minWidth: 100,
  },
  {
    Header: () => headerOperation('Cúmulo General (UF)'),
    id: 'cumulo_general',
    accessor: i => cellNumOperation(i.balance.cumulo),
    sortable: false,
    filterable: false,
    minWidth: 100,
  },
  {
    Header: () => headerDoubleRowOperation('Cúmulo Venta en', 'Verde (UF)'),
    id: 'cumulo_proyectos',
    accessor: i => (
      i.organizacion.roles.includes('afianzadoventaenverde')
        ? cellNumOperation(i.balance.cumulo_proyectos)
        : cellOperation('-', 'right')
    ),
    sortable: false,
    filterable: false,
    minWidth: 100,
  },
  {
    Header: () => headerOperation('Cupo General restante (UF)'),
    id: 'cupo_restante',
    accessor: i => cellNumOperation(i.balance.cupo_restante),
    sortable: false,
    filterable: false,
    minWidth: 100,
  },
  {
    Header: () => headerOperation('Último cambio'),
    headerClassName: 'fecha',
    id: 'fecha',
    accessor: i => cellOperation(moment(i.actualizacion_ts).format('DD/MM/YYYY')),
    sortable: false,
    filterable: false,
    minWidth: 100,
  },
  {
    Header: () => headerOperation('Acciones'),
    id: 'acciones',
    accessor: i => cellOperation(
      (
        <Icon
          link
          className="table-link"
          url={`/garantia/clientes/${i.id}/detalle`}
          id={`detail-${i.id}`}
          tooltipText={(<span className="detail-tooltip">Ver Detalle</span>)}
        >
          <FontAwesomeIcon icon={faEye} className="table-link" />
        </Icon>
      )
    ),
    width: 85,
    sortable: false,
    filterable: false,
  },
];

function mapDispatchToProps(dispatch) {
  return {
    createLine: client => dispatch(postData(client)),
    getClients: client => dispatch(getData(client)),
    resetData: client => dispatch(cleanData(client)),
  };
}

class ClientList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      modalOpen: false,
      gruposOptions: [],
      grupo: undefined,
    };
    this.filtering = false;
    this.table = React.createRef();

    this.fetchData = this.fetchData.bind(this);
    this.fetchDataWithDebounce = _.debounce(this.fetchData, SEARCH_DELAY_MS);
    this.fetchStrategy = this.fetchStrategy.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.onFilteredChange = this.onFilteredChange.bind(this);
  }

  componentDidMount() {
    get(`${BASE_URL}${API.grupos_economicos}`).then((response) => {
      this.setState({
        gruposOptions: response.map((option) => {
          return {
            label: option.nombre,
            value: option.id,
          }
        })
      })
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { success } = this.props;
    const { grupo } = this.state;
    if (prevProps.success !== success && success) {
      this.handleSuccess()
    }
    if (prevState.grupo !== grupo) {
      this.fetchStrategy(this.table.current.state);
    }
  }

  onFilteredChange() {
    this.filtering = true;
  }

  handleSuccess() {
    const { resetData, update } = this.props;
    this.setState({ loading: true });
    if (update) {
      this.fetchStrategy(this.table.current.state);
    }
    resetData();
    this.setState({
      loading: false,
      modalOpen: false,
    });
  }

  handleModal(e) {
    e.preventDefault();
    const { modalOpen } = this.state;
    this.setState({
      modalOpen: !modalOpen,
    });
  }

  fetchStrategy(tableState) {
    if (this.filtering) {
      return this.fetchDataWithDebounce(tableState);
    }
    return this.fetchData(tableState);
  }

  fetchData(state) {
    const { getClients } = this.props;
    const { grupo } = this.state;
    this.filtering = false;
    this.setState({ loading: true });
    let filters = `${BASE_URL}${API.lineasGarantia}?page=${state.page + 1}&`;
    if (state.filtered && state.filtered.length) {
      state.filtered.forEach(node => {
        if (node.value.length !== 0 && node.value.length > 3) {
          const id = (node.id === 'rut' || node.id === 'nombre')
            ? 'organizacion'
            : node.id;
          filters = `${filters}${id}=${node.value}&`;
        }
      });
    }
    if (grupo) {
      filters = `${filters}grupo_id=${grupo.value}`
    }
    getClients({
      url: filters,
      name: 'users',
      type: GET_MOVIMIENTOS_LIST,
    });
  }

  handleSubmit(config, onFailedReq = () => (null)) {
    const { createLine } = this.props;
    createLine({
      url: `${BASE_URL}${API.lineasGarantia}`,
      type: CREATE_LINE,
      onFailedReq,
      config
    })
  }

  render() {
    const { clients } = this.props;
    const { loading, modalOpen, grupo, gruposOptions } = this.state;
    return (
      <PageContainer
        breadcrumbs={[
          { id: 0, name: 'RIESGO', url: '/' },
          { id: 1, name: 'GARANTÍA', url: '/' },
          { id: 2, name: 'DETALLE CLIENTE' },
        ]}
      >
        <Row>
          <Col sm="3" xs="6">
            <Select
              value={grupo}
              options={gruposOptions}
              onChange={(e) => this.setState({ grupo: e })}
              isClearable
            />
          </Col>
          <Col sm="2" xs="4">
            <div className="button-container">
              <DownloadBtn
                className="blue"
                id="xlsx-download"
                text="XLSX"
                tipText="Descargar Reporte Grupos. Esto se puede demorar unos minutos"
                url={`${BASE_URL}${API.lineasGarantia}download_xlsx?${grupo ? `grupo_id=${grupo.value}` : ''}`}
              />
            </div>
          </Col>
        </Row>
        {grupo && (
          <RowCardsGroup
            grupoId={grupo.value}
            key={grupo.value}
          />
        )}
        <div className="table-container">
          {isUserHasProfile(GARANTIA_WRITE) && (
            <div className="button-container d-flex justify-content-end">
              <Button
                className="blue"
                onClick={this.handleModal}
              >
                Abrir nueva línea
              </Button>
            </div>
          )}
          <BaseTable
            className="client-list"
            columns={columns}
            data={clients.data}
            filterable
            loading={loading}
            onFetchData={this.fetchStrategy}
            onFilteredChange={this.onFilteredChange}
            pages={clients.pages}
            resizable={false}
            resultCount={clients.count}
            showPagination
            style={{ height: '55vh' }}
            tableRef={this.table}
          />
        </div>
        {modalOpen && (
          <CreateClientLine
            handleModal={this.handleModal}
            modalOpen={modalOpen}
            handleSubmit={this.handleSubmit}
          />
        )}
      </PageContainer>
    );
  }
}

const mapStateToProps = state => ({
  clients: state.clients.listData,
  success: state.clients.successMessage,
  update: state.clients.updateState,
});

ClientList.propTypes = {
  clients: PropTypes.shape({
    count: PropTypes.number,
    data: PropTypes.arrayOf(PropTypes.object),
    next: PropTypes.string,
    pages: PropTypes.number,
    previous: PropTypes.string,
  }).isRequired,
  createLine: PropTypes.func.isRequired,
  getClients: PropTypes.func.isRequired,
  resetData: PropTypes.func.isRequired,
  success: PropTypes.bool.isRequired,
  update: PropTypes.bool.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClientList);
